import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {isDesktop, isMobile, isTablet} from "@/Helpers/Function";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
// import Slider from "react-slick";
import {Breadcrumbs} from "@mui/material";
import ScrollMagic from "scrollmagic/scrollmagic/uncompressed/ScrollMagic";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Pages/Collections/scss/story.scss';

class Story extends React.Component {
    componentDidMount = () => {
        reachGoalYM('story');
        reachGoalGA('story');
        this.sceneAll();
    }

    sceneAll = () => {
        const controller = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            triggerElement: "#wrapper1",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrapper1", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrapper2",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrapper2", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrapper3",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrapper3", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrapper4",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrapper4", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrapper5",
            triggerHook: 0.9,
            offset: -100,
        })
            .setClassToggle("#wrapper5", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrapper7",
            triggerHook: 0.9,
            offset: -100,
        })
            .setClassToggle("#wrapper7", "visible")
            .addTo(controller);
    }

    render() {
        const {stores = {}, uploadUrl = ''} = this.props;
        const {modalStore = {}, collectionsStore = {}} = stores;

        const AddAiOutlineArrowLeft = (props) => (
            <div className={`arrows-collections arrows-collections__left`} onClick={props.onClick}></div>
        );

        const AddAiOutlineArrowRight = (props) => (
            <div className={`arrows-collections arrows-collections__right`} onClick={props.onClick}></div>
        );

        const settings = {
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            infinite: true,
            dots: false,
            dotsClass: 'slick-main-dots',
            fade: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: false,
            className: '',
            prevArrow: <AddAiOutlineArrowLeft />,
            nextArrow: <AddAiOutlineArrowRight />,
            appendDots: dots => (
                <ul> {dots} </ul>
            ),
            customPaging: () => (
                <span></span>
            )
        };

        const settings1 = {
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            infinite: false,
            dots: false,
            dotsClass: 'slick-main-dots',
            fade: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: false,
            className: '',
        };

        const element = collectionsStore.storyData.map((el) => {

            return <div key={el.id}
                        className={`slider__item`}>
                <img key={el.id}
                     className={`image`}
                     loading={`lazy`}
                     src={el.imgPath}
                     alt={`Красивое фото`}
                     title={`Красивое фото`}
                />
            </div>;
        });

        const element1 = collectionsStore.minimaStepsData.map((el) => {
            return <div key={el.id}
                        className={`steps__item`}>
                <img key={el.id}
                     loading={`lazy`}
                     src={el.imgPath}
                     alt={`Красивое фото`}
                     title={`Красивое фото`}
                />
                <p className={`steps__info`}>{el.text}</p>
            </div>;
        });

        return <>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className="container">
                        <Breadcrumbs maxItems={3} itemsAfterCollapse={3}>
                            <Link className={`breadcrumbs__link`} href={`/`}>
                                Главная
                            </Link>
                            <Link className={`breadcrumbs__link`} href={`/collections`}>
                                Коллекции
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Живая сказка
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`collections-lp`}>
                    <div className={`container`}>
                        <div className={`skazka-video`}>
                            <div className={`video-box`}>
                                {isDesktop() || isTablet() ?
                                    <video id={`video`}
                                           preload={`none`}
                                           width={`100%`}
                                           poster={`/storage/img/collections/skazka/live_story_1280х720.jpg`}
                                    >
                                        <source
                                            src={`${uploadUrl}/media/video/collections/skazka/live_story_1280х720.mp4`}
                                            type={`video/mp4`} />
                                    </video>
                                    :
                                    <video id={`video`}
                                           width={`100%`}
                                           preload={`metadata`}
                                           poster={`/storage/img/collections/skazka/live_story_mobile.jpg`}
                                    >
                                        <source
                                            src={`${uploadUrl}/media/video/collections/skazka/live_story_mobile.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/skazka/live_story_mobile.webm`}
                                            type={`video/webm`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/skazka/live_story_mobile.ogg`}
                                            type={`video/ogg`} />
                                    </video>
                                }
                            </div>
                            <div className={`video-control`}
                                 onClick={() => collectionsStore.mediaNorthernLightsMainPlayPause()}>
                                {collectionsStore.videoStorySvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => collectionsStore.mediaStory()}></div>
                                    </>
                                    :
                                    <>
                                        {collectionsStore.videoNorthernLightsMainPlayPauseFlag ?
                                            <div className={`gg-pause-button`}
                                                 onClick={() => collectionsStore.mediaStory()}></div>
                                            : null
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div id={`wrapper1`} className={`wrapper wrapper__1`}>
                        <div className={`bg bg__color-1`}></div>
                        <div className={`bg bg__1`}></div>
                        <div className={`bg bg__2`}></div>
                        <div className={`container`}>
                            <p className={`wrapper__1_text`}>В&nbsp;коллекции воплощены образы, знакомые нам
                                по&nbsp;легендам и&nbsp;сказкам.
                                Узнай, какими будут твои идеальные спутники в&nbsp;сказочном мире ювелирной
                                магии...</p>
                            <p className={`wrapper__1_title`}>Откройся сказке,</p>
                            <p className={`wrapper__1_subtitle`}>почувствуй волшебство…</p>
                            <div className={`open-skazka`}>
                                {isDesktop() ?
                                    <>
                                        <div className={`open-skazka__item open-skazka__item_1`}>
                                            <img className={`image1`}
                                                 src={`/storage/img/collections/skazka/block1/1.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                            <img className={`image3`}
                                                 src={`/storage/img/collections/skazka/block1/2.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                        </div>
                                        <div className={`open-skazka__item open-skazka__item_2`}>
                                            <p className={`description`}>
                                                Тема яркого, солнечного и&nbsp;ласкового лета раскрывается
                                                в&nbsp;богатстве
                                                образов нежной и&nbsp;романтичной коллекции &laquo;Живая
                                                сказка&raquo;.
                                                Анималистичные силуэты&nbsp;&mdash; один из&nbsp;самых излюбленных
                                                сюжетов ювелирного бренда PLATINA.
                                            </p>
                                            <img className={`image2`}
                                                 src={`/storage/img/collections/skazka/block1/3.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                        </div>
                                    </>
                                    :
                                    <div className={`open-skazka__item open-skazka__item_1`}>
                                        <img className={`image1`}
                                             src={`/storage/img/collections/skazka/block1/1.png`}
                                             loading={`lazy`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                        <p className={`description`}>
                                            Тема яркого, солнечного и&nbsp;ласкового лета раскрывается
                                            в&nbsp;богатстве
                                            образов нежной и&nbsp;романтичной коллекции &laquo;Живая
                                            сказка&raquo;.
                                            Анималистичные силуэты&nbsp;&mdash; один из&nbsp;самых излюбленных
                                            сюжетов ювелирного бренда PLATINA.
                                        </p>
                                        <img className={`image2`}
                                             src={`/storage/img/collections/skazka/block1/3.png`}
                                             loading={`lazy`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                    </div>
                                }
                            </div>
                            <p className={`description description__2`}>
                                Отойдя от&nbsp;привычного нам реализма, мы&nbsp;сосредоточились на&nbsp;стилизации,
                                чтобы подчеркнуть волшебство и&nbsp;сказочность этих украшений. Нежный оттенок
                                серебра дополнен яркими акцентами: натуральные камни усиливают потенциал изделий,
                                а&nbsp;живописная эмаль привносит ещё больше магии.
                            </p>
                        </div>
                    </div>
                    <div id={`wrapper2`} className={`wrapper wrapper__2`}>
                        <div className={`bg bg__color-2`}></div>
                        <div className={`bg bg__3`}></div>
                        <div className={`container`}>
                            <div className={`animalism`}>
                                <div className={`animalism__item animalism__item_1`}>
                                    <Link
                                        href={`/catalog/product/02-4640-00-274-0200-68?utm_source=lp_skazka&utm_medium=product_02-4640-00-274-0200-68&utm_campaign=l`}>
                                        <img className={`image1`}
                                             src={`/storage/img/collections/skazka/block2/1.png`}
                                             loading={`lazy`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                    </Link>
                                </div>
                                <div className={`animalism__item animalism__item_2`}>
                                    <div>
                                        <p className={`title`}>Анималистика</p>
                                        <p className={`description`}>
                                            Восходящий тренд сезона, о&nbsp;котором все так мечтали. Когда природа
                                            вокруг расцветает буйством красок, когда воздух пропитан энергией
                                            солнца,
                                            так хочется добавить в&nbsp;образ яркую деталь, в&nbsp;которой
                                            скрывается
                                            особое послание...
                                        </p>
                                    </div>
                                    <div>
                                        <p className={`title`}>Образы животных и насекомых</p>
                                        <p className={`description`}>
                                            Не&nbsp;просто красиво дополняют наш гардероб, но&nbsp;и&nbsp;служат
                                            мощными
                                            талисманами! А&nbsp;магия натуральных камней усиливает их&nbsp;потенциал
                                            и&nbsp;придаёт украшениям особую живость.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p className={`description description__3`}>
                                Эти украшения&nbsp;&mdash; настоящий праздник жизни во&nbsp;всех
                                её&nbsp;проявлениях. Богатство мира ювелирной фауны от&nbsp;PLATINA вдохновляет
                                на&nbsp;эксперименты с&nbsp;образом и&nbsp;предлагает приключение, от&nbsp;которого
                                невозможно отказаться!
                            </p>
                        </div>
                    </div>
                    <div id={`wrapper3`} className={`wrapper wrapper__3`}>
                        <div className={`bg bg__4`}></div>
                        <div className={`frog`}>
                            <img className={`image1`}
                                 src={`/storage/img/collections/skazka/block3/1.png`}
                                 loading={`lazy`}
                                 alt={`Красивое фото`}
                                 title={`Красивое фото`}
                            />
                        </div>
                        <div className={`container`}>
                            <div className={`fabulous-images`}>
                                {isDesktop() ?
                                    <>
                                        <div className={`fabulous-images__item fabulous-images__item_1`}>
                                            <p className={`title title__3`}>Сказочные</p>
                                            <p className={`subtitle subtitle__3`}>образы</p>
                                            <p className={`description description__4`}>
                                                Коллекция &laquo;Живая сказка&raquo;&nbsp;&mdash; это изящная
                                                стилизация,
                                                где за&nbsp;каждой лёгкой, неприхотливой линией и&nbsp;силуэтом
                                                скрывается
                                                глубокое, вдохновляющее послание или шифр.
                                            </p>
                                            <p className={`description description__4`}>
                                                Натуральные камни в&nbsp;украшениях данной
                                                коллекции&nbsp;&mdash; это
                                                самостоятельный элемент дизайна. Они привносят в&nbsp;каждое изделие
                                                свой
                                                неповторимый, завораживающий магнетизм и&nbsp;усиливают впечатление.
                                            </p>
                                            <p className={`description description__5`}>
                                                Эти украшения&nbsp;&mdash; для тех, кто ценит энергию цвета!
                                                Техника &laquo;глухая эмаль&raquo; обеспечивает в&nbsp;изделиях
                                                насыщенный,
                                                глубокий оттенок. И&nbsp;всё благодаря тому, что каждый штрих здесь
                                                выполнен
                                                вручную, он&nbsp;уникален и&nbsp;неповторим.
                                            </p>
                                            <Link href={`/catalog/zhivaya-skazka`}
                                                      className={`btn btn__skazka`}
                                            >
                                                Смотреть все украшения
                                            </Link>
                                        </div>
                                        <div className={`fabulous-images__item fabulous-images__item_2`}>
                                            <img className={`image1`}
                                                 src={`/storage/img/collections/skazka/block3/2.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                        </div>
                                    </>
                                    :
                                    <div className={`fabulous-images__item fabulous-images__item_1`}>
                                        <p className={`title title__3`}>Сказочные</p>
                                        <p className={`subtitle subtitle__3`}>образы</p>
                                        <p className={`description description__4 description_frog`}>
                                            Коллекция &laquo;Живая сказка&raquo;&nbsp;&mdash; это изящная
                                            стилизация,
                                            где за&nbsp;каждой лёгкой, неприхотливой линией и&nbsp;силуэтом
                                            скрывается
                                            глубокое, вдохновляющее послание или шифр.
                                        </p>
                                        <p className={`description description__4`}>
                                            Натуральные камни в&nbsp;украшениях данной коллекции&nbsp;&mdash; это
                                            самостоятельный элемент дизайна. Они привносят в&nbsp;каждое изделие
                                            свой
                                            неповторимый, завораживающий магнетизм и&nbsp;усиливают впечатление.
                                        </p>
                                        <img className={`image1`}
                                             src={`/storage/img/collections/skazka/block3/2.png`}
                                             loading={`lazy`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                        <p className={`description description__5`}>
                                            Эти украшения&nbsp;&mdash; для тех, кто ценит энергию цвета!
                                            Техника &laquo;глухая эмаль&raquo; обеспечивает в&nbsp;изделиях
                                            насыщенный,
                                            глубокий оттенок. И&nbsp;всё благодаря тому, что каждый штрих здесь
                                            выполнен
                                            вручную, он&nbsp;уникален и&nbsp;неповторим.
                                        </p>
                                        <Link href={`/catalog/zhivaya-skazka`}
                                                  className={`btn btn__skazka`}
                                        >
                                            Смотреть все украшения
                                        </Link>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div id={`wrapper4`} className={`wrapper wrapper__4`}>
                        <div className={`bg bg__color-3`}></div>
                        <div className={`bg bg__5`}></div>
                        <div className={`container`}>
                            <div className={`elegant`}>
                                {isDesktop() ?
                                    <>
                                        <div className={`elegant__item elegant__item_1`}>
                                            <img className={`image1`}
                                                 src={`/storage/img/collections/skazka/block4/1.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                        </div>
                                        <div className={`elegant__item elegant__item_2`}>
                                            <p className={`title title__4`}>изящный <HeartSvg /></p>
                                            <p className={`subtitle subtitle__4`}>и романтичный</p>
                                            <p className={`description description__4`}>
                                                Сказочные образы, вдохновлённые летним солнцем и&nbsp;игрой цвета,
                                                привносят
                                                в&nbsp;образ элемент загадки и&nbsp;особую чувственность.
                                            </p>
                                            <Link
                                                href="/catalog/product/02-4635-00-274-0200-68?utm_source=lp_skazka&utm_medium=product_02-4635-00-274-0200-68&utm_campaign=l">
                                                <img className={`image1`}
                                                     src={`/storage/img/collections/skazka/block4/2.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                            <p className={`description description__5`}>
                                                Эти украшения&nbsp;&mdash; твой пропуск в&nbsp;мир раскованной
                                                непринуждённости, натуральности и&nbsp;лёгкого изящества. Они
                                                идеально
                                                сочетаются и&nbsp;с&nbsp;динамичным, городским гардеробом,
                                                и&nbsp;с&nbsp;образами в&nbsp;стиле кантри или фолк.
                                            </p>
                                        </div>
                                    </>
                                    :
                                    <div className={`elegant__item elegant__item_1`}>
                                        <p className={`title title__4`}>изящный <HeartSvg /></p>
                                        <p className={`subtitle subtitle__4`}>и романтичный</p>
                                        <img className={`image1`}
                                             src={`/storage/img/collections/skazka/block4/1.png`}
                                             loading={`lazy`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                        <p className={`description description__4`}>
                                            Сказочные образы, вдохновлённые летним солнцем и&nbsp;игрой цвета,
                                            привносят
                                            в&nbsp;образ элемент загадки и&nbsp;особую чувственность.
                                        </p>
                                        <Link
                                            href="/catalog/product/02-4635-00-274-0200-68?utm_source=lp_skazka&utm_medium=product_02-4635-00-274-0200-68&utm_campaign=l">
                                            <img className={`image1`}
                                                 src={`/storage/img/collections/skazka/block4/2.png`}
                                                 loading={`lazy`}
                                                 alt={`Красивое фото`}
                                                 title={`Красивое фото`}
                                            />
                                        </Link>
                                        <p className={`description description__5`}>
                                            Эти украшения&nbsp;&mdash; твой пропуск в&nbsp;мир раскованной
                                            непринуждённости, натуральности и&nbsp;лёгкого изящества. Они
                                            идеально
                                            сочетаются и&nbsp;с&nbsp;динамичным, городским гардеробом,
                                            и&nbsp;с&nbsp;образами в&nbsp;стиле кантри или фолк.
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div id={`wrapper5`} className={`wrapper wrapper__5`}>
                        <div className={`bg bg__6`}></div>
                        <div className={`container`}>
                            <div className={`random-decorations-skazka`}>
                                <div
                                    className={`random-decorations-skazka__item random-decorations-skazka__item_1`}>
                                    <div className={`element element__item_1`}>
                                        <div className={`element__img`}>
                                            <Link
                                                href={`/catalog/product/03-3188-01-000-0200-71?utm_source=lp_skazka&utm_medium=product_03-3188-01-000-0200-71&utm_campaign=l`}>
                                                <img className={`image1`}
                                                     src={`/storage/img/collections/skazka/block5/strekoza.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                        <div className={`element__text element__text_1`}>
                                            <p className={`element__title`}>Стрекоза</p>
                                            <p className={`element__description`}>В&nbsp;образе стрекоз скрывается
                                                множество тайных смыслов. В&nbsp;японской культуре они олицетворяют
                                                отвагу; у&nbsp;американских индейцев&nbsp;&mdash; скорость.
                                                В&nbsp;Европе&nbsp;же их&nbsp;сравнивали&nbsp;с... драконами,
                                                наделяя могуществом и&nbsp;магической силой.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`element element__item_3`}>
                                        <div className={`element__text element__text_3`}>
                                            <p className={`element__title`}>Заколдованная принцесса или страж</p>
                                            <p className={`element__description`}>
                                                Лягушки населяют сказочные леса испокон веков, и&nbsp;всегда
                                                олицетворяют собой нечто большее... Кто это? Заколдованная принцесса
                                                или страж, скрывающий переход из&nbsp;реальности в&nbsp;мир магии
                                                и&nbsp;волшебства? На&nbsp;Востоке серебряная лягушка является
                                                талисманом богатства.
                                            </p>
                                        </div>
                                        <div className={`element__img`}>
                                            <Link
                                                href={`/catalog/product/02-4654-00-000-0200-71?utm_source=lp_skazka&utm_medium=product_02-4654-00-000-0200-71&utm_campaign=l`}>
                                                <img className={`image3`}
                                                     src={`/storage/img/collections/skazka/block5/lyagyshka.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className={`element element__item_4`}>
                                        <div className={`element__img`}>
                                            <Link
                                                href={`/catalog/product/02-4661-00-102-0200-72?utm_source=lp_skazka&utm_medium=product_02-4661-00-102-0200-72&utm_campaign=l`}>
                                                <img className={`image4`}
                                                     src={`/storage/img/collections/skazka/block5/babochka.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                        <div className={`element__text element__text_4`}>
                                            <p className={`element__title`}>бабочка</p>
                                            <p className={`element__description`}>
                                                Очень лёгкий и&nbsp;нежный символ
                                                лета&nbsp;&mdash; бабочка&nbsp;&mdash; в&nbsp;исполнении ювелиров
                                                PLATINA придаёт образу изысканность и&nbsp;лёгкую игривость. Являясь
                                                символом бесконечной и&nbsp;бессмертной души, бабочки
                                                из&nbsp;коллекции &laquo;Живая сказка&raquo; открывают в&nbsp;образе
                                                особую, возвышенную лёгкость
                                                и&nbsp;романтизм.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`element element__item_6`}>
                                        <div className={`element__text element__text_6`}>
                                            <p className={`element__title`}>Образ змейки</p>
                                            <p className={`element__description`}>
                                                Образ змейки из&nbsp;этого комплекта вдохновлён символикой
                                                кадуцея&nbsp;&mdash; жезла Гермеса, который до&nbsp;сих пор
                                                во&nbsp;многих культурах считается символом медицины
                                                и&nbsp;врачевания. Усиливают образ натуральные камни
                                                огранки &laquo;груша&raquo; (бриолет) в&nbsp;подвеске:
                                                их&nbsp;называют &laquo;очарование Франции&raquo;,
                                                и&nbsp;их&nbsp;главная особенность в&nbsp;том, что они изящно
                                                и&nbsp;нежно подчёркивают линию шеи. В&nbsp;комплекте также
                                                представлены серьги на&nbsp;английском замке и&nbsp;изысканный
                                                браслет.
                                            </p>
                                        </div>
                                        <div className={`element__img element__img_6`}>
                                            <Link
                                                href={`/catalog/product/02-4665-00-204-0200-68?utm_source=lp_skazka&utm_medium=product_02-4665-00-204-0200-68&utm_campaign=l`}>
                                                <img className={`image6`}
                                                     src={`/storage/img/collections/skazka/block5/zmeya-2.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className={`element element__item_7`}>
                                        <div className={`element__img element__img_7`}>
                                            <Link
                                                href={`/catalog/product/02-4656-00-000-0200-68?utm_source=lp_skazka&utm_medium=product_02-4656-00-000-0200-68&utm_campaign=l`}>
                                                <img className={`image7`}
                                                     src={`/storage/img/collections/skazka/block5/kobra.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                        <div className={`element__text element__text_7`}>
                                            <p className={`element__title`}>кобра</p>
                                            <p className={`element__description`}>Символ высшей божественной
                                                и&nbsp;царской мудрости, власти и&nbsp;сакрального знания.
                                                На&nbsp;Востоке кобру почитают как священное животное. Один
                                                из&nbsp;самых известных образов
                                                в&nbsp;культуре&nbsp;&mdash; волшебная змея Нага, хранительница
                                                сокровищ.</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`random-decorations-skazka__item random-decorations-skazka__item_2`}>
                                    <div className={`element element__item_2`}>
                                        <div className={`element__img element__img_2`}>
                                            <Link
                                                href={`/catalog/product/02-4634-00-274-0200-68?utm_source=lp_skazka&utm_medium=product_02-4634-00-274-0200-68&utm_campaign=l`}>
                                                <img className={`image2`}
                                                     src={`/storage/img/collections/skazka/block5/sova.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                        <div className={`element__text element__text_2`}>
                                            <p className={`element__title element__title_2`}>Мудрая сова</p>
                                            <p className={`element__description`}>
                                                Излюбленный сказочный персонаж всех народов мира&nbsp;&mdash; мудрая
                                                сова. Олицетворяя тайное знание и&nbsp;мудрость, она служит
                                                проводником в&nbsp;тайный мир волшебства. С&nbsp;отважным героем она
                                                всегда готова поделиться своими секретами, но&nbsp;заслужить
                                                её&nbsp;доверие не&nbsp;так просто.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`element element__item_5`}>
                                        <div className={`element__text element__text_5`}>
                                            <p className={`element__title`}>Пустынный воин – скорпион</p>
                                            <p className={`element__description`}>
                                                олицетворяет скрытую силу, достоинство и&nbsp;отвагу. Это опасный
                                                противник, от&nbsp;которого бегут и&nbsp;звери, и&nbsp;птицы. Такой
                                                спутник может стать сильнейшим талисманом,
                                                предупреждающим: &laquo;с&nbsp;моей владелицей шутки плохи!&raquo;
                                            </p>
                                        </div>
                                        <div className={`element__img element__img_5`}>
                                            <Link
                                                href={`/catalog/product/02-4636-00-202-0200-68?utm_source=lp_skazka&utm_medium=product_02-4636-00-202-0200-68&utm_campaign=l`}>
                                                <img className={`image5`}
                                                     src={`/storage/img/collections/skazka/block5/scorpion.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className={`element element__item_8`}>
                                        <div className={`element__text element__text_8`}>
                                            <p className={`element__title`}>Силуэт змеи</p>
                                            <p className={`element__description`}>
                                                Силуэт змеи&nbsp;&mdash; это символ мудрости, обновления
                                                и&nbsp;изобилия. Этот образ олицетворяет богиню мудрости Афину
                                                и&nbsp;бога света Аполлона Дельфийского. Народы маори наделяли змею
                                                умением прокладывать пути в&nbsp;неизведанное. Шумеры воплотили
                                                в&nbsp;её&nbsp;облике могущественную богиню Тиамат, из&nbsp;которой
                                                была создана Вселенная. Комплект фактурных украшений из&nbsp;серебра
                                                представляет собой полный гарнитур из&nbsp;серёг, подвески
                                                и&nbsp;браслета, вручную расписанных глухой эмалью.
                                            </p>
                                        </div>
                                        <div className={`element__img`}>
                                            <Link
                                                href={`/catalog/product/05-0646-00-000-0200-68?utm_source=lp_skazka&utm_medium=product_05-0646-00-000-0200-68&utm_campaign=l`}>
                                                <img className={`image8`}
                                                     src={`/storage/img/collections/skazka/block5/zmeya-1.png`}
                                                     loading={`lazy`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <Link href={`/catalog/zhivaya-skazka`}
                                              className={`btn btn__skazka`}
                                    >
                                        Смотреть все украшения
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className={`wrapper wrapper__6`}>*/}
                    {/*    <div className={`bg bg__color-4`}></div>*/}
                    {/*    <div className={`bg bg__7`}></div>*/}
                    {/*    <div className={`container`}>*/}
                    {/*        <div className={`slider__collections-lp`}>*/}
                    {/*            {isMobile() ? ''*/}
                    {/*                :*/}
                    {/*                <div className={`branch`}></div>*/}
                    {/*            }*/}
                    {/*            <div className={`slider__image`}>*/}
                    {/*                <Slider ref={slider => (this.slider = slider)} {...settings}>*/}
                    {/*                    {element}*/}
                    {/*                </Slider>*/}
                    {/*            </div>*/}
                    {/*            <div className={`slider__content`}>*/}
                    {/*                <p className={`full-image__title`}>*/}
                    {/*                    Выиграй уникальный приз!*/}
                    {/*                </p>*/}
                    {/*                <a href="https://promo.platina-kostroma.shop/regform/"*/}
                    {/*                   className={`btn btn__skazka btn__skazka_slider`}*/}
                    {/*                   target={`_blank`}>*/}
                    {/*                    Участвовать в розыгрыше*/}
                    {/*                </a>*/}
                    {/*                <p className={`full-image__conditions`}*/}
                    {/*                   onClick={() => modalStore.openModalConditionsPromotion()}>*/}
                    {/*                    <DocumentSvg /> Условия акции*/}
                    {/*                </p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div id={`wrapper7`} className={`wrapper wrapper__7`}>*/}
                    {/*    <div className={`container`}>*/}
                    {/*        {isMobile() ?*/}
                    {/*            <div className={`steps`}>*/}
                    {/*                <Slider ref={slider => (this.slider = slider)} {...settings1}>*/}
                    {/*                    {element1}*/}
                    {/*                </Slider>*/}
                    {/*            </div>*/}
                    {/*            :*/}
                    {/*            <div className={`steps`}>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-1.png`}*/}
                    {/*                         loading={`lazy`}*/}
                    {/*                         alt={`Отсканируй QR-код`}*/}
                    {/*                         title={`Отсканируй QR-код`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Отсканируй QR-код</p>*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item steps__item_2 steps__item_triple-chevron`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-arrows.png`}*/}
                    {/*                         loading={`lazy`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-2-1.png`}*/}
                    {/*                         loading={`lazy`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Заполни анкету</p>*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item steps__item_2 steps__item_triple-chevron`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-arrows.png`}*/}
                    {/*                         loading={`lazy`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-3.png`}*/}
                    {/*                         loading={`lazy`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Участвуй в розыгрыше!</p>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </section>
        </>
    }
}

const DocumentSvg = () => (
    <Svg id={`document`} className={`svg__document`} />
)

const HeartSvg = () => (
    <Svg id={`heartLp`} className={`svg__heartLp`} />
)

export default useWithStore(Story);
